export const useTableData = <T>(
  records: T[] | undefined | null,
  keySelector: (record: T, index: number) => string,
  sorter?: (data: T[]) => T[]
) => {
  if (!records) return [];

  return (sorter?.(records) ?? records).map((r, i) => ({
    key: keySelector(r, i),
    ...r,
  }));
};
